import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface FilterListIconProps extends SvgIconProps {}

export const FilterListIcon = ({
  ...iconProps
}: FilterListIconProps): ReactElement => {
  return (
    <SvgIcon {...iconProps} viewBox="0 0 24 24">
      <mask
        id="mask0_filter_list"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_filter_list)">
        <path
          d="M10.5578 17V16H13.423V17H10.5578ZM6.80775 12.5V11.5H17.173V12.5H6.80775ZM4 8V7H20V8H4Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};
